import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { BumpButton, EButtonColor, EButtonSize } from '../button';
import { EllipsisButton } from '../ellipsis';
import { OrderBumpItems } from '../../order/order-bump-items';
import { OrderUtils, SortType } from '@lib/common';
import { OrderIcon, SilverIcon, ReadyIcon, PickupIcon, MotobikeIcon } from './card-icon';
import { ChangeStatusModal } from '../modals/changeStatus';
import { EstimatedTime } from './estimate-time';
import { CommonText } from '../commonText';
import { FaChevronDown, FaChevronUp, FaClock, FaInfoCircle } from 'react-icons/fa';
import { DeliveryProvider } from '../deliveryProvider';
import { PrintOrder } from './print';
const getColorBasedOnService = (serviceType) => {
    switch (serviceType) {
        case 'dine_in':
            return '#E79900';
        case 'delivery':
            return '#00B2B2';
        default:
            return '#0082E0';
    }
};
const getWidthBasedOnSetting = (view_mode, settingPerPage, row) => {
    if (view_mode === 'desktop_view') {
        if (row === 1) {
            switch (settingPerPage) {
                case 4:
                    return '31rem';
                case 5:
                    return '24rem';
                case 6:
                    return '20rem';
                default:
                    return '24rem';
            }
        }
        else {
            switch (settingPerPage) {
                case 4:
                    return '63rem';
                case 6:
                    return '41rem';
                case 10:
                    return '25rem';
                case 12:
                    return '20rem';
                default:
                    return '31rem';
            }
        }
    }
    else {
        if (row === 1) {
            switch (settingPerPage) {
                case 3:
                    return '42rem';
                case 4:
                    return '30rem';
                case 5:
                    return '24rem';
                default:
                    return '30rem';
            }
        }
        else {
            switch (settingPerPage) {
                case 4:
                    return '63rem';
                case 6:
                    return '41rem';
                case 10:
                    return '25rem';
                case 12:
                    return '20rem';
                default:
                    return '31rem';
            }
        }
    }
};
const BumpCardWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: ${({ widthCard, row, view_mode }) => getWidthBasedOnSetting(view_mode, widthCard, row)};
  border-radius: 4px;
  border: 1px solid #d7d7d7;
  box-shadow: 0px 2px 4px 0px #0000001a;
  border: ${({ allSelected }) => allSelected ? '2px solid var(--status-completed, #009100)' : '2px solid transparent'};
  @media (max-width: 1690px) {
    min-width: calc(${({ widthCard, row, view_mode }) => getWidthBasedOnSetting(view_mode, widthCard, row)} * 0.8);
  }
  @media (max-width: 1370px) {
    min-width: calc(${({ widthCard, row, view_mode }) => getWidthBasedOnSetting(view_mode, widthCard, row)} * 0.6);
  }
  @media (max-width: 1105px) {
    min-width: calc(${({ widthCard, row, view_mode }) => getWidthBasedOnSetting(view_mode, widthCard, row)} * 0.55);
  }
  @media (max-width: 1075px) {
    min-width: calc(${({ widthCard, row, view_mode }) => getWidthBasedOnSetting(view_mode, widthCard, row)} * 0.5);
  }
  @media (max-width: 768px) {
    min-width: calc(${({ widthCard, row, view_mode }) => getWidthBasedOnSetting(view_mode, widthCard, row)} * 0.3);
  }
`;
export const ServiceStyle = styled.div `
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background-color: ${({ service }) => getColorBasedOnService(service)};
  color: #fefefe;
`;
export const CardHeader = styled.div `
  background: #fefefe;
  padding: 12px 12px 0 12px;
  color: #4b4f5e;
  border-radius: 4px 4px 0 0;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const CardHeaderRight = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 130px;
  div {
    margin-left: 4px;
    margin-right: 4px;
  }
`;
export const HeaderRightItem = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
`;
export const CardDetails = styled.div `
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dfdfdf;
  font-size: 14px;
  font-weight: 500;
  .card-detail-order {
    color: '#4b4f5e';
  }
  .card-detail-text {
    color: ${({ allSelected }) => (allSelected ? '#009100' : '#4b4f5e')};
  }
`;
export const CardDetailsLeft = styled.div `
  display: flex;
  align-items: center;
  > svg {
    margin-right: 4px;
  }
`;
const CardBody = styled.div `
  min-height: ${({ row, view_mode }) => {
    if (view_mode === 'desktop_view') {
        return row === 1 ? '65vh' : '26vh';
    }
    else if (view_mode === 'tablet_view') {
        return row === 1 ? '59rem' : '25rem';
    }
    else {
        return row === 1 ? '65vh' : '26vh';
    }
}};
  background-color: #fff;
  @media only screen and (max-height: 600px) {
    min-height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '43vh';
    }
    else {
        return '27vh';
    }
}};
  }
  @media only screen and (min-height: 601px) and (max-height: 755px) {
    min-height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '54vh';
    }
    else {
        return '27vh';
    }
}};
  }
  @media only screen and (min-height: 756px) and (max-height: 862px) {
    min-height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '63vh';
    }
    else {
        return '27vh';
    }
}};
  }
  @media only screen and (min-height: 863px) and (max-height: 950px) {
    min-height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '66vh';
    }
    else {
        return '25vh';
    }
}};
  }
  @media only screen and (min-height: 951px) and (max-height: 1063px) {
    min-height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '70vh';
    }
    else {
        return '27vh';
    }
}};
  }
  @media only screen and (min-height: 1064px) and (max-height: 1200px) {
    height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '74vh';
    }
    else {
        return '30vh';
    }
}};
  }
  @media only screen and (min-height: 1201px) and (max-height: 1331px) {
    min-height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '75vh';
    }
    else {
        return '33vh';
    }
}};
  }
  @media only screen and (min-height: 1332px){
    min-height: ${({ view_mode, row }) => {
    if (view_mode === 'desktop_view' && row === 1) {
        return '79vh';
    }
    else {
        return '35vh';
    }
}};
  }
`;
const CardItemsWrapper = styled.div ``;
const BodyItem = styled.div `
  display: flex;
  border-bottom: 1px dashed #dfdfdf;
  padding: 12px;
  justify-content: space-between;
  background: ${({ active }) => (active ? 'rgba(0, 145, 0, 0.05)' : '#fff')};
`;
const BodyItemLeft = styled.div `
  display: flex;
  font-size: 16px;
  margin-right: 3px;
  color: #0c202a;
  font-weight: 600;
  line-height: 24px;
`;
const BodyItemCenterDish = styled.div `
  color: #0c202a;
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 600;
  line-height: 24px;
  margin-left: 4px;
`;
const BodyItemCenterOptionSet = styled.div `
  color: #4b4f5e;
  font-size: 12px;
  margin-bottom: 8px;
  font-weight: 500;
  line-height: 24px;
  margin-left: 44px;
`;
const BodyItemRight = styled.div `
  width: 10%;
  text-align: center;
`;
const RadioButtonLabel = styled.label `
  position: relative;
  margin-right: 16px;
  cursor: pointer;
  user-select: none;
`;
const RadioButtonCustom = styled.span `
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 50%;
`;
const RadioButtonChecked = styled.svg `
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
`;
const CardFooter = styled.div `
  background: #fefefe;
  border-top: 1px solid #dfdfdf;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  svg {
    margin-right: 4px;
  }
`;
const ActionCardWrap = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
`;
const CustomerNameStyle = styled.div `
  font-size: 14px;
  color: #808b88;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
const NoteWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #dfdfdf;
`;
const NoteTxt = styled.div `
  line-height: 1em;
  max-height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ expandNotes }) => (expandNotes ? '' : '2')};
  word-break: break-word;
  overflow: hidden;
`;
const TopCardSection = styled.div `
  background: #fff;
`;
const ContentCardWrapper = styled.div `
  max-height: ${({ row }) => (row === 1 ? '59vh' : '22vh')};
  @media only screen (max-height: 600px) {
    height: ${({ row }) => {
    if (row === 1) {
        return '42vh';
    }
    else {
        return '27vh';
    }
}};
  }
  @media only screen and (min-height: 601px) and (max-height: 755px) {
    height: ${({ row }) => {
    if (row === 1) {
        return '48vh';
    }
    else {
        return '27vh';
    }
}};
  }
  @media only screen and (min-height: 756px) and (max-height: 900px) {
    height: ${({ row }) => {
    if (row === 1) {
        return '56vh';
    }
    else {
        return '27vh';
    }
}};
  }
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #4b4f5e;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;
export const mapToServiceName = (key) => {
    switch (key) {
        case 'dine_in':
            return (React.createElement(React.Fragment, null,
                React.createElement(SilverIcon, null),
                ' ',
                React.createElement(CommonText, { size: "semiMedium", weight: 400 }, "Dine in")));
        case 'pickup':
            return (React.createElement(React.Fragment, null,
                React.createElement(PickupIcon, null),
                ' ',
                React.createElement(CommonText, { size: "semiMedium", weight: 400 }, "Pickup")));
        case 'delivery':
            return (React.createElement(React.Fragment, null,
                React.createElement(MotobikeIcon, null),
                ' ',
                React.createElement(CommonText, { size: "semiMedium", weight: 400 }, "Delivery")));
        default:
            return null;
    }
};
export const BumpCard = (props) => {
    const { order, handleReady, handleSelectOption, handleSelectPrinter, isDisableModal, setIsDisableModal, onDeleteOrder, orderStatusData, printerNames, settingCard, onUpdateOrderDish, permissionDelete, } = props;
    const [showAction, setShowAction] = useState(false);
    const [selectedItemIds, setSelectedItemIds] = useState([]);
    const [changeStatusActive, setChangeStatusActive] = useState(false);
    const [estimateTime, setEstimateTime] = useState(0);
    const [activeReadyTimeModal, setActiveReadyTimeModal] = useState(false);
    const [activePrintersModal, setActivePrinterModal] = useState(false);
    const [expandNotes, setExpandNotes] = useState(false);
    const handleBodySelected = (el, idx) => {
        const isIdExisted = selectedItemIds.includes(el._id);
        let newStatus = '';
        if (!isIdExisted) {
            setSelectedItemIds([...selectedItemIds, el._id]);
            newStatus = 'complete';
        }
        else {
            const filteredIds = selectedItemIds.filter(item => item !== el._id);
            setSelectedItemIds(filteredIds);
            newStatus = 'pending';
        }
        const statusParam = newStatus === 'complete' ? 'complete' : 'pending';
        const paramOderLineLocator = {
            "dish_id": el._id,
            "price": el.price,
            "index": idx,
        };
        onUpdateOrderDish(order._id, statusParam, el.line_id, paramOderLineLocator);
    };
    const handleMoreAction = () => {
        setShowAction(prev => !prev);
    };
    const handleExpandNotes = () => {
        setExpandNotes(prev => !prev);
    };
    const handleSetEstimated = () => {
        setActiveReadyTimeModal(true);
    };
    const handlePrint = () => {
        if (printerNames.length !== 1) {
            setActivePrinterModal(true);
        }
        else {
            handleSelectPrinter(order, printerNames[0]._id);
            setShowAction(false);
        }
    };
    const handleDeleteOrder = () => {
        onDeleteOrder(order);
    };
    const handleOpenChangeStatusModal = () => {
        setChangeStatusActive(true);
    };
    const handleSelectOptionTime = (order, time) => {
        handleSelectOption(order, time);
        setEstimateTime(parseInt(time));
    };
    const listActionOrder = [
        { label: 'Change Status', onClick: handleOpenChangeStatusModal },
        { label: `Set Estimated ${OrderUtils.getTextByService(order)} Time`, onClick: handleSetEstimated },
        { label: 'Print', onClick: handlePrint },
    ];
    if (permissionDelete) {
        listActionOrder.push({ label: 'Delete Order', onClick: handleDeleteOrder });
    }
    useEffect(() => {
        if (isDisableModal) {
            setActiveReadyTimeModal(false);
            setIsDisableModal(false);
        }
        if (order.dishes.length) {
            const completedDishes = order.dishes.filter((item) => item.order_status === 'complete');
            const selectedIds = completedDishes.map((item) => item._id);
            setSelectedItemIds(selectedIds);
        }
    }, [isDisableModal, order]);
    const renderCardHeaderRight = (order) => {
        if (order && order.config && order.config.service) {
            const serviceName = order.config.service;
            if (serviceName === 'delivery' && order.delivery_in && order.delivery_in.timestamp) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(FaClock, null),
                    React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" },
                        new Date(order.delivery_in.timestamp - Date.now()).getMinutes() + estimateTime,
                        " Mins")));
            }
            if (order.ready_in && order.ready_in.timestamp) {
                return (React.createElement(React.Fragment, null,
                    serviceName === 'dine_in' && React.createElement("div", null, order.config.table),
                    React.createElement(FaClock, null),
                    React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" },
                        new Date(order.ready_in.timestamp - Date.now()).getMinutes() + estimateTime,
                        " Mins")));
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(FaClock, null),
                React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" },
                    estimateTime,
                    " Mins")));
        }
        return React.createElement(React.Fragment, null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BumpCardWrapper, { allSelected: selectedItemIds.length === order.dishes.length, widthCard: settingCard.card, row: settingCard.row, view_mode: settingCard.view_mode },
            React.createElement(TopCardSection, null,
                React.createElement(CardHeader, null,
                    React.createElement(ServiceStyle, { service: order.config.service }, mapToServiceName(order.config.service)),
                    React.createElement(CardHeaderRight, null, renderCardHeaderRight(order))),
                React.createElement(CardBody, { row: settingCard.row, view_mode: settingCard.view_mode },
                    React.createElement(CardDetails, { allSelected: selectedItemIds.length === order.dishes.length },
                        React.createElement(CardDetailsLeft, null,
                            React.createElement(DeliveryProvider, { provider: order.config.delivery_provider }),
                            React.createElement(OrderIcon, null),
                            React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" }, order.number),
                            React.createElement(CustomerNameStyle, { className: "m-l-1" },
                                "- ",
                                order.customer.name)),
                        React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" },
                            selectedItemIds.length,
                            " / ",
                            order.dishes.length,
                            " Items")),
                    React.createElement(ContentCardWrapper, { row: settingCard.row },
                        order.notes && (React.createElement(NoteWrapper, null,
                            React.createElement("div", { style: { display: 'flex' } },
                                React.createElement("div", { style: { color: 'blue' } },
                                    React.createElement(FaInfoCircle, null)),
                                React.createElement(NoteTxt, { className: "m-l-1", expandNotes: expandNotes }, order.notes)),
                            order.notes.length >= 115 && (React.createElement("div", { onClick: handleExpandNotes },
                                expandNotes ? React.createElement(FaChevronUp, null) : React.createElement(FaChevronDown, null),
                                " ")))),
                        !showAction ? (React.createElement(CardItemsWrapper, { row: settingCard.row, view_mode: settingCard.view_mode }, order.dishes.map((el, idx) => (React.createElement(BodyItem, { key: idx, active: selectedItemIds.includes(el._id), onClick: () => handleBodySelected(el, idx) },
                            React.createElement("div", null,
                                React.createElement(BodyItemLeft, null,
                                    React.createElement(CommonText, { size: "medium", weight: 600, color: "#0C202A" }, el.qty < 10 ? `0${el.qty}` : el.qty),
                                    React.createElement(CommonText, { size: "medium", weight: 600, color: "#0C202A" }, "\u00A0x"),
                                    React.createElement(BodyItemCenterDish, null,
                                        React.createElement(CommonText, { size: "medium", weight: 600, color: "#0C202A" }, el.name))),
                                React.createElement(BodyItemCenterOptionSet, null,
                                    React.createElement(OrderBumpItems, { items: el, renderDetails: {
                                            enabled: true,
                                            prices: false,
                                            option_prices: false,
                                            combo_choice_names: true,
                                            sort_type: SortType.ByCart.toString(),
                                        } }))),
                            React.createElement(BodyItemRight, null,
                                React.createElement(RadioButtonLabel, null, selectedItemIds.includes(el._id) ? (React.createElement(RadioButtonChecked, { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                    React.createElement("mask", { id: "mask0_268_3914", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24" },
                                        React.createElement("rect", { width: "24", height: "24", fill: "#D9D9D9" })),
                                    React.createElement("g", { mask: "url(#mask0_268_3914)" },
                                        React.createElement("path", { d: "M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z", fill: "#009100" })))) : (React.createElement(RadioButtonCustom, null))))))))) : (React.createElement(ActionCardWrap, { className: "child-mb-7" }, listActionOrder.map((button, index) => (React.createElement(BumpButton, { key: index, onClick: button.onClick },
                            React.createElement("p", null, button.label))))))))),
            React.createElement(CardFooter, null, !showAction ? (React.createElement(React.Fragment, null,
                React.createElement(BumpButton, { size: EButtonSize.LARGE, color: EButtonColor.SUCCESS, onClick: () => handleReady(order, 'ready') },
                    React.createElement(ReadyIcon, null),
                    React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#F1F4F7" }, "Ready")),
                React.createElement("div", { onClick: handleMoreAction },
                    React.createElement(EllipsisButton, null)))) : (React.createElement(BumpButton, { size: EButtonSize.LARGE, color: EButtonColor.PRIMARY, onClick: () => setShowAction(false) }, "Back")))),
        React.createElement(ChangeStatusModal, { selectedItemIds: selectedItemIds, order: order, changeStatusActive: changeStatusActive, setChangeStatusActive: setChangeStatusActive, handleChangeStatus: handleReady, orderStatusData: orderStatusData }),
        React.createElement(EstimatedTime, { order: order, active: activeReadyTimeModal, setChangeStatusActive: setActiveReadyTimeModal, handleSelectOption: handleSelectOptionTime }),
        React.createElement(PrintOrder, { order: order, active: activePrintersModal, setChangeStatusActive: setActivePrinterModal, handleSelectPrinter: handleSelectPrinter, printerNames: printerNames })));
};
//# sourceMappingURL=index.js.map